import { call } from "@/service";
import constants from "./landingConstants";

export default {
  namespaced: true,
  state: {
    company: {},
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.value;
    },
  },
  getters: {
    landingGetters: (state) => (val) => state[val],
  },
  actions: {
    getCompanyInfo: ({ commit }) => {
      commit("SET_LOADING", true, { root: true });

      call("get", constants.company)
        .then((res) => {
          commit("MUTATE", { state: "company", value: res.data.data });
          commit("SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },
  },
};
